import { Layout } from "@layouts";
import { Button } from "@atoms";
import { PageBreadcrumbs } from "@molecules";
import { PagePaths } from "../../../../types";

export type LifestyleCompletePageTemplateProps = {
  navigateToPage: (to: string) => void;
  onReturnPressed: () => void;
  onSendEmails: () => void;
};

export const LifestyleCompletePageTemplate = ({
  navigateToPage,
  onReturnPressed,
  onSendEmails
}: LifestyleCompletePageTemplateProps): JSX.Element => {
  const goToPerks = () => navigateToPage(`/dashboard/${PagePaths.perks}`);
  const goToLifestyleMain = () => navigateToPage(`/dashboard/${PagePaths.lifestyle}/main`);

  return (
    <Layout
      variant="dashboard"
      header="Lifestyle Account"
      subheader={
        <div className="flex flex-row justify-between max-w-5xl">
          <div className="page-subtitle mt-2">
            Automate reimbursements on select expenses
          </div>
        </div>
      }
    >
      <div className="flex flex-col h-full">
        <PageBreadcrumbs
          items={[
            { label: "Benefits", onClick: goToPerks },
            { label: "Lifestyle Account", onClick: goToLifestyleMain },
            { label: "Complete" },
          ]}
        />
        <div className="flex flex-col items-center justify-center flex-1 pb-8 mt-12">
          {/* Success Content */}
          <div className="text-center max-w-lg">
            {/* Success Icon */}
            <div className="mb-6">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
                <span className="text-4xl">✅</span>
              </div>
            </div>

            {/* Success Message */}
            <h2 className="text-2xl font-bold text-gray-900 mb-4">
              Lifestyle Account Activated!
            </h2>
            
            <p className="text-gray-600 mb-8 leading-relaxed">
              Your lifestyle benefits have been successfully activated for your employees. 
              An email notification has been sent to all employees informing them about their new benefits.
            </p>

            {/* Return Home Button */}
            <Button
              onClick={onSendEmails}
              variant="primary"
              label="See your lifestyle group"
              color="brand-orange"
              hoverColor="primary-dark"
              size="md"
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}; 
